import { createSvgIcon } from '@mui/material';

const RecordIcon = createSvgIcon(
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16.0013 19.333C18.2146 19.333 20.0013 17.5463 20.0013 15.333V7.33301C20.0013 5.11967 18.2146 3.33301 16.0013 3.33301C13.788 3.33301 12.0013 5.11967 12.0013 7.33301V15.333C12.0013 17.5463 13.788 19.333 16.0013 19.333ZM14.668 7.33301C14.668 6.59967 15.268 5.99967 16.0013 5.99967C16.7346 5.99967 17.3346 6.59967 17.3346 7.33301V15.333C17.3346 16.0663 16.7346 16.6663 16.0013 16.6663C15.268 16.6663 14.668 16.0663 14.668 15.333V7.33301ZM22.668 15.333C22.668 19.013 19.6813 21.9997 16.0013 21.9997C12.3213 21.9997 9.33464 19.013 9.33464 15.333H6.66797C6.66797 20.0397 10.148 23.9063 14.668 24.5597V28.6663H17.3346V24.5597C21.8546 23.9063 25.3346 20.0397 25.3346 15.333H22.668Z'
      fill='#1749D1'
    />
  </svg>,
  'Record',
);

export default RecordIcon;
